<template>
  <Tabs :tabs="tabs" :style="2">
    <template #tab-content-1>
      <ProfileUserSettings />
    </template>
    <template #tab-content-2>
      <GeneralUserSettings />
    </template>
    <template #tab-content-3>
      <SecurityUserSettings />
    </template>
  </Tabs>
</template>
<script setup lang="ts">
import Tabs from '@app/components/Global/Tabs/Tabs.vue'
import GeneralUserSettings from './General.vue'
import SecurityUserSettings from './Security.vue'
import ProfileUserSettings from './Profile.vue'
const tabs = [
  {
    number: 1,
    title: 'Profile',
  },
  {
    number: 2,
    title: 'General',
  },
  {
    number: 3,
    title: 'Security',
  },
]
</script>
